<ng-container *ngIf="havePermissionGroup">
  <app-group-configurations-list></app-group-configurations-list>
</ng-container>
<ng-container *ngIf="havePermissionGroup && havePermissionBuildConfig">
  <app-group-configuration-filter></app-group-configuration-filter>
</ng-container>
